import { render } from "./lateral.vue?vue&type=template&id=143abae0"
import script from "./lateral.vue?vue&type=script&lang=js"
export * from "./lateral.vue?vue&type=script&lang=js"

import "./lateral.vue?vue&type=style&index=0&id=143abae0&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__